import { createFileRoute } from "@tanstack/react-router";
import { SwitchboardDashboard } from "../tools/dashboards/SwitchboardDashboard";

export const Route = createFileRoute("/_app/dashboards/switchboard")({
  component: SwitchboardDashboard,
});
